module.exports = __webpack_public_path__ + "6f742a9d1983a28f6a5cadaac69cdbcd.jpg";